import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import toolbar from './modules/toolbar'
import auth from './modules/auth'
import filter from './modules/filter'
import alert from './modules/alert'
import permissionmenu from './modules/permissionmenu'


Vue.use(Vuex)

const store = new Vuex.Store({
    modules: {
        app,
        toolbar,
        auth,
        filter,
        alert,
        permissionmenu
    }
})

export default store